import React from "react";
import Button from "components/button";

const Footerbuttonupdate = ({
    formIndex,
    isNonEU,
    oC1, // Close modal
    oC2, // Submit all documents
    oC3, // Next step
}) => {
    // Non-EU: identity + selfie + visa (7 steps)
    // 1: Confirmation, 2: Identity, 3: Check identity, 4: Selfie, 5: Check selfie, 6: Visa, 7: Check visa + Submit
    const elementsNonEU = [
        <Button key={0} size={"LG"} onClick={oC1}>Fermer</Button>,           // Step 1: Confirmation
        <Button key={1} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 2: Identity upload
        <Button key={2} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 3: Check identity
        <Button key={3} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 4: Selfie upload
        <Button key={4} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 5: Check selfie
        <Button key={5} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 6: Visa upload
        <Button key={6} size={"LG"} onClick={oC2}>Modifier</Button>,         // Step 7: Check visa + Submit all
    ];

    // EU: identity + selfie only (5 steps)
    // 1: Confirmation, 2: Identity, 3: Check identity, 4: Selfie, 5: Check selfie + Submit
    const elementsEU = [
        <Button key={0} size={"LG"} onClick={oC1}>Fermer</Button>,           // Step 1: Confirmation
        <Button key={1} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 2: Identity upload
        <Button key={2} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 3: Check identity
        <Button key={3} size={"LG"} onClick={oC3}>Suivant</Button>,          // Step 4: Selfie upload
        <Button key={4} size={"LG"} onClick={oC2}>Modifier</Button>,         // Step 5: Check selfie + Submit all
    ];

    const elements = isNonEU ? elementsNonEU : elementsEU;

    return (
        <>
            {elements.filter((item, index) => index + 1 === formIndex)}
        </>
    );
};

export default Footerbuttonupdate;
